module.exports = __webpack_public_path__ + "static/media/photo_unavailable.a412e4f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo_unavailable.jpg
// module id = 57
// module chunks = 0